// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","wrapper":"header_wrapper__E5g1B"};